import { render, staticRenderFns } from "./FormScript.vue?vue&type=template&id=6549af0a&"
import script from "./FormScript.vue?vue&type=script&lang=js&"
export * from "./FormScript.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports